import { Link } from 'react-router-dom';
import MainLayout from '@/components/layout/MainLayout';
import { Button } from '@/components/ui/button';
import { CheckCircle } from 'lucide-react';

const ContactSuccessPage = () => {
  return (
    <MainLayout>
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-2xl mx-auto text-center">
          <div className="mb-8">
            <CheckCircle className="h-16 w-16 text-green-500 mx-auto" />
          </div>
          <h1 className="text-3xl font-bold text-hotel-primary mb-4">Thank You for Contacting Us!</h1>
          <p className="text-gray-600 mb-8">
            We've received your message and will get back to you within 24 hours.
            In the meantime, feel free to explore more about Lobier and how we can help your hotel.
          </p>
          <Link to="/">
            <Button className="bg-hotel-primary hover:bg-hotel-primary/90">
              Return to Homepage
            </Button>
          </Link>
        </div>
      </div>
    </MainLayout>
  );
};

export default ContactSuccessPage; 